"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VARIATIONS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaTheme = _interopRequireDefault(require("@thinkific/toga-theme"));

var _CircularSpinner = _interopRequireDefault(require("./CircularSpinner.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var cx = _bind["default"].bind(_CircularSpinner["default"]);

var VARIATIONS = ['default', 'small', 'medium', 'large', 'xlarge'];
exports.VARIATIONS = VARIATIONS;

var CircularSpinner = function CircularSpinner(_ref) {
  var _theme$color, _theme$spinner;

  var className = _ref.className,
      color = _ref.color,
      variation = _ref.variation;
  var theme = (0, _react.useContext)(_togaTheme["default"]);
  var borderColor = color;

  if (theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color.primary) {
    borderColor = theme.color.primary;
  }

  if (theme === null || theme === void 0 ? void 0 : (_theme$spinner = theme.spinner) === null || _theme$spinner === void 0 ? void 0 : _theme$spinner.color) {
    borderColor = theme.spinner.color;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx(['spinner', "spinner--".concat(variation), className])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('circle')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('circle-inner'),
    style: {
      borderLeftColor: borderColor,
      borderTopColor: borderColor
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: cx(['circle', 'circle-2'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('circle-inner'),
    style: {
      borderLeftColor: borderColor,
      borderTopColor: borderColor
    }
  })));
};

CircularSpinner.propTypes = {
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].object]),
  color: _propTypes["default"].string,
  variation: _propTypes["default"].string
};
CircularSpinner.defaultProps = {
  className: null,
  color: null,
  variation: 'default'
};
var _default = CircularSpinner;
exports["default"] = _default;